module.exports = __webpack_public_path__ + "img/active-feature-bullet.99ffd98.svg";